


// // import React, { useEffect, useState } from 'react';
// // import { styled } from '@mui/material/styles';
// // import SideNav from '../SideNav';
// // import { useParams } from 'react-router-dom';
// // import { 
// //     Box, 
// //     Typography, 
// //     Paper, 
// //     TextField, 
// //     Button, 
// //     Table, 
// //     TableBody, 
// //     TableCell, 
// //     TableContainer, 
// //     TableHead, 
// //     TableRow, 
// //     Chip, 
// //     Alert,
// //     Container,
// //     CircularProgress,
// //     useTheme,
// //     useMediaQuery,
// //     Drawer,
// //     IconButton,
// //     Stack,
// //     Card,
// //     CardContent,
// //     Grid,
// //     AppBar,
// //     Toolbar
// // } from '@mui/material';
// // import { getDatabase, ref, onValue } from 'firebase/database';
// // import { withRouter } from 'react-router-dom';
// // import PatientDetails from './PatientDetails';
// // import MenuIcon from '@mui/icons-material/Menu';
// // import SearchIcon from '@mui/icons-material/Search';
// // import ViewDetailsIcon from '@mui/icons-material/Visibility';
// // import CloseIcon from '@mui/icons-material/Close';
// // import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// // const drawerWidth = 240;

// // const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
// //   ({ theme, open }) => ({
// //     flexGrow: 1,
// //     padding: theme.spacing(3),
// //     transition: theme.transitions.create('margin', {
// //       easing: theme.transitions.easing.sharp,
// //       duration: theme.transitions.duration.leavingScreen,
// //     }),
// //     marginLeft: `-${drawerWidth}px`,
// //     ...(open && {
// //       transition: theme.transitions.create('margin', {
// //         easing: theme.transitions.easing.easeOut,
// //         duration: theme.transitions.duration.enteringScreen,
// //       }),
// //       marginLeft: 0,
// //     }),
// //     [theme.breakpoints.down('sm')]: {
// //       padding: theme.spacing(2),
// //       marginLeft: 0,
// //       width: '100%',
// //     },
// //   }),
// // );

// // const DrawerHeader = styled('div')(({ theme }) => ({
// //   display: 'flex',
// //   alignItems: 'center',
// //   padding: theme.spacing(0, 1),
// //   ...theme.mixins.toolbar,
// //   justifyContent: 'flex-end',
// // }));

// // const DoctorDashboard = ({ doctorId, history }) => {
// //     const [appointments, setAppointments] = useState([]);
// //     const [searchTerm, setSearchTerm] = useState('');
// //     const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
// //     const [showDetails, setShowDetails] = useState(false);
// //     const [loading, setLoading] = useState(true);
// //     const theme = useTheme();
// //     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// //     const isTablet = useMediaQuery(theme.breakpoints.down('md'));

// //     useEffect(() => {
// //         console.log("📋 Fetching appointments for doctor:", doctorId);
        
// //         const fetchAppointments = async () => {
// //             try {
// //                 const appointmentsRef = ref(
// //                     getDatabase(),
// //                     `doctor/${doctorId}/appointments`
// //                 );
                
// //                 onValue(appointmentsRef, (snapshot) => {
// //                     const appointmentsArray = [];
                    
// //                     if (snapshot.exists()) {
// //                         snapshot.forEach((childSnapshot) => {
// //                             const appointmentId = childSnapshot.key;
// //                             const appointmentData = childSnapshot.val();
                            
// //                             appointmentsArray.push({
// //                                 id: appointmentId,
// //                                 appointmentId: appointmentData.appointmentId || appointmentId,
// //                                 patientName: appointmentData.patientName || 'Not provided',
// //                                 patientAge: appointmentData.patientAge || 'N/A',
// //                                 patientEmail: appointmentData.patientEmail || 'Not provided',
// //                                 patientPhone: appointmentData.patientPhone || appointmentData.patientMobile || 'Not provided',
// //                                 patientID: appointmentData.patientID || 'N/A',
// //                                 date: appointmentData.date || 'Not provided',
// //                                 timeSlot: appointmentData.timeSlot || 'Not specified',
// //                                 healthIssues: appointmentData.healthIssues || 'Not provided',
// //                                 symptoms: appointmentData.symptoms || appointmentData.healthIssues || appointmentData.description || 'Not provided',
// //                                 description: appointmentData.description || 'Not provided',
// //                                 medicalHistory: appointmentData.medicalHistory || 'None',
// //                                 currentMedications: appointmentData.currentMedications || 'None',
// //                                 status: appointmentData.status || 'Pending',
// //                                 paymentStatus: appointmentData.paymentStatus || appointmentData.payment || 'Pending',
// //                                 paymentMethod: appointmentData.paymentMethod || 'Not specified',
// //                                 doctorName: appointmentData.doctorName || 'Doctor',
// //                                 doctorUID: appointmentData.doctorUID || appointmentData.doctorId,
// //                                 clinicName: appointmentData.clinicName || "Doctor's Clinic",
// //                                 bookingDate: appointmentData.bookingDate || appointmentData.createdAt,
// //                                 prescription: appointmentData.prescription || '',
// //                                 prescriptionDate: appointmentData.prescriptionDate,
// //                                 completedAt: appointmentData.completedAt
// //                             });
// //                         });
                        
// //                         console.log("✅ Loaded appointments:", appointmentsArray.length);
// //                     } else {
// //                         console.log("❌ No appointments found in database");
// //                     }
                    
// //                     setAppointments(appointmentsArray);
// //                     setLoading(false);
// //                 });
// //             } catch (error) {
// //                 console.error('❌ Error fetching doctor appointments:', error);
// //                 setLoading(false);
// //             }
// //         };

// //         fetchAppointments();
// //     }, [doctorId]);

// //     const handleCardClick = (appointmentId) => {
// //         console.log("👁️ Viewing appointment:", appointmentId);
// //         setSelectedAppointmentId(appointmentId);
// //         setShowDetails(true);
// //     };

// //     const handleSearch = (e) => {
// //         setSearchTerm(e.target.value.toLowerCase());
// //     };

// //     const handleBackToAppointments = () => {
// //         setShowDetails(false);
// //         setSelectedAppointmentId(null);
// //     };

// //     const formatAppointmentDate = (date) => {
// //         if (!date || date === 'Not provided') return 'N/A';
        
// //         if (date.includes('/')) {
// //             return date;
// //         }
        
// //         try {
// //             const dateObj = new Date(date);
// //             if (!isNaN(dateObj.getTime())) {
// //                 return dateObj.toLocaleDateString('en-US', {
// //                     month: '2-digit',
// //                     day: '2-digit',
// //                     year: 'numeric'
// //                 });
// //             }
// //         } catch (error) {
// //             console.error('Error formatting date:', error);
// //         }
        
// //         return date;
// //     };

// //     const convertTo24HourFormat = (timeSlot) => {
// //         if (!timeSlot || timeSlot === 'Not specified') return '00:00';
        
// //         try {
// //             const [time, period] = timeSlot.split(' ');
// //             let [hours, minutes] = time.split(':');

// //             if (period === 'PM' && hours !== '12') {
// //                 hours = String(Number(hours) + 12);
// //             } else if (period === 'AM' && hours === '12') {
// //                 hours = '00';
// //             }

// //             hours = hours.padStart(2, '0');
// //             minutes = minutes.padStart(2, '0');

// //             return `${hours}:${minutes}`;
// //         } catch (error) {
// //             return '00:00';
// //         }
// //     };

// //     const getStatusColor = (status) => {
// //         switch (status?.toLowerCase()) {
// //             case 'completed':
// //                 return 'success';
// //             case 'confirmed':
// //                 return 'primary';
// //             case 'pending':
// //                 return 'warning';
// //             case 'cancelled':
// //                 return 'error';
// //             default:
// //                 return 'default';
// //         }
// //     };

// //     const getPaymentColor = (paymentStatus) => {
// //         return paymentStatus?.toLowerCase() === 'pending' ? 'warning' : 'success';
// //     };

// //     const renderMobileAppointmentCard = (appointment, index) => {
// //         return (
// //             <Card 
// //                 key={appointment.id}
// //                 sx={{ 
// //                     mb: 2, 
// //                     borderLeft: `4px solid ${getStatusColor(appointment.status) === 'success' ? '#4caf50' : 
// //                                  getStatusColor(appointment.status) === 'primary' ? '#1976d2' : 
// //                                  getStatusColor(appointment.status) === 'warning' ? '#ff9800' : '#f44336'}`,
// //                     transition: 'transform 0.2s',
// //                     '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 }
// //                 }}
// //             >
// //                 <CardContent sx={{ p: 2 }}>
// //                     <Stack spacing={1.5}>
// //                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
// //                             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
// //                                 {appointment.patientName}
// //                             </Typography>
// //                             <Chip 
// //                                 label={appointment.status} 
// //                                 color={getStatusColor(appointment.status)} 
// //                                 size="small"
// //                                 sx={{ fontSize: '0.75rem' }}
// //                             />
// //                         </Box>
                        
// //                         <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
// //                             <Typography variant="body2" color="textSecondary">
// //                                 Age: {appointment.patientAge} {appointment.patientAge !== 'N/A' ? 'yrs' : ''}
// //                             </Typography>
// //                             <Typography variant="body2" color="textSecondary">
// //                                 ID: {appointment.patientID}
// //                             </Typography>
// //                         </Box>
                        
// //                         <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
// //                             📱 {appointment.patientPhone}
// //                         </Typography>
                        
// //                         <Typography variant="body2" sx={{ 
// //                             color: '#666',
// //                             display: '-webkit-box',
// //                             WebkitLineClamp: 2,
// //                             WebkitBoxOrient: 'vertical',
// //                             overflow: 'hidden',
// //                             fontSize: '0.875rem'
// //                         }}>
// //                             {appointment.symptoms}
// //                         </Typography>
                        
// //                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //                             <Box>
// //                                 <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
// //                                     {formatAppointmentDate(appointment.date)}
// //                                 </Typography>
// //                                 <Typography variant="caption" color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
// //                                     🕐 {appointment.timeSlot}
// //                                 </Typography>
// //                             </Box>
// //                             <Button 
// //                                 onClick={() => handleCardClick(appointment.id)} 
// //                                 variant="contained"
// //                                 size="small"
// //                                 startIcon={<ViewDetailsIcon />}
// //                                 sx={{ 
// //                                     backgroundColor: '#1976d2',
// //                                     fontSize: '0.75rem',
// //                                     '&:hover': { backgroundColor: '#1565c0' }
// //                                 }}
// //                             >
// //                                 View
// //                             </Button>
// //                         </Box>
                        
// //                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //                             <Chip 
// //                                 label={appointment.paymentStatus} 
// //                                 color={getPaymentColor(appointment.paymentStatus)} 
// //                                 size="small"
// //                                 sx={{ fontSize: '0.75rem' }}
// //                             />
// //                             <Typography variant="caption" color="textSecondary">
// //                                 #{index + 1}
// //                             </Typography>
// //                         </Box>
// //                     </Stack>
// //                 </CardContent>
// //             </Card>
// //         );
// //     };

// //     const renderAppointmentsByDate = () => {
// //         const filteredAppointments = appointments.filter((appointment) => {
// //             if (!searchTerm) return true;
            
// //             const searchLower = searchTerm.toLowerCase();
// //             const formattedDate = formatAppointmentDate(appointment.date).toLowerCase();
// //             const patientName = (appointment.patientName || '').toLowerCase();
// //             const symptoms = (appointment.symptoms || '').toLowerCase();
            
// //             return formattedDate.includes(searchLower) || 
// //                    patientName.includes(searchLower) || 
// //                    symptoms.includes(searchLower);
// //         });

// //         filteredAppointments.sort((a, b) => {
// //             const dateCompare = new Date(a.date) - new Date(b.date);
// //             if (dateCompare !== 0) return dateCompare;
            
// //             const timeA = convertTo24HourFormat(a.timeSlot);
// //             const timeB = convertTo24HourFormat(b.timeSlot);
// //             return timeA.localeCompare(timeB);
// //         });

// //         if (filteredAppointments.length === 0) {
// //             return (
// //                 <Box sx={{ 
// //                     textAlign: 'center', 
// //                     py: 8,
// //                     backgroundColor: '#fafafa',
// //                     borderRadius: 2,
// //                     border: '1px dashed #ddd'
// //                 }}>
// //                     <Typography variant="h6" color="textSecondary" gutterBottom>
// //                         📅 No Appointments Found
// //                     </Typography>
// //                     <Typography variant="body2" color="textSecondary">
// //                         {searchTerm ? 'Try adjusting your search terms' : 'No appointments scheduled yet'}
// //                     </Typography>
// //                 </Box>
// //             );
// //         }

// //         if (isMobile) {
// //             return (
// //                 <Box sx={{ mt: 2 }}>
// //                     {filteredAppointments.map((appointment, index) => 
// //                         renderMobileAppointmentCard(appointment, index)
// //                     )}
// //                 </Box>
// //             );
// //         }

// //         return (
// //             <TableContainer 
// //                 component={Paper} 
// //                 sx={{ 
// //                     borderRadius: 2,
// //                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
// //                     overflowX: 'auto',
// //                     maxWidth: '100%',
// //                     mx: 'auto'
// //                 }}
// //             >
// //                 <Table sx={{ minWidth: isTablet ? 800 : 1200 }}>
// //                     <TableHead sx={{ backgroundColor: '#1976d2' }}>
// //                         <TableRow>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 50 }}>#</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 150 }}>Patient</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 80 }}>Age</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 180 }}>Contact</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 200 }}>Symptoms</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 120 }}>Date</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 120 }}>Time</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 100 }}>Status</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 100 }}>Payment</TableCell>
// //                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 120 }}>Action</TableCell>
// //                         </TableRow>
// //                     </TableHead>
// //                     <TableBody>
// //                         {filteredAppointments.map((appointment, index) => (
// //                             <TableRow 
// //                                 key={appointment.id}
// //                                 hover
// //                                 sx={{ 
// //                                     '&:hover': { backgroundColor: '#f5f9ff' },
// //                                     backgroundColor: index % 2 === 0 ? 'white' : '#fafafa',
// //                                     transition: 'background-color 0.2s'
// //                                 }}
// //                             >
// //                                 <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>{index + 1}</TableCell>
// //                                 <TableCell>
// //                                     <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
// //                                         {appointment.patientName}
// //                                     </Typography>
// //                                     <Typography variant="caption" color="textSecondary">
// //                                         ID: {appointment.patientID}
// //                                     </Typography>
// //                                 </TableCell>
// //                                 <TableCell>
// //                                     <Chip 
// //                                         label={`${appointment.patientAge} ${appointment.patientAge !== 'N/A' ? 'yrs' : ''}`}
// //                                         size="small"
// //                                         variant="outlined"
// //                                         sx={{ borderColor: '#1976d2', color: '#1976d2' }}
// //                                     />
// //                                 </TableCell>
// //                                 <TableCell>
// //                                     <Stack spacing={0.5}>
// //                                         <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
// //                                             📱 {appointment.patientPhone}
// //                                         </Typography>
// //                                         <Typography variant="caption" color="textSecondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
// //                                             📧 {appointment.patientEmail}
// //                                         </Typography>
// //                                     </Stack>
// //                                 </TableCell>
// //                                 <TableCell sx={{ maxWidth: '200px' }}>
// //                                     <Typography variant="body2" sx={{ 
// //                                         overflow: 'hidden',
// //                                         textOverflow: 'ellipsis',
// //                                         whiteSpace: 'nowrap'
// //                                     }}>
// //                                         {appointment.symptoms}
// //                                     </Typography>
// //                                 </TableCell>
// //                                 <TableCell>
// //                                     <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
// //                                         {formatAppointmentDate(appointment.date)}
// //                                     </Typography>
// //                                 </TableCell>
// //                                 <TableCell>
// //                                     <Chip 
// //                                         label={appointment.timeSlot}
// //                                         color="primary" 
// //                                         size="small"
// //                                         variant="outlined"
// //                                         sx={{ fontWeight: 'bold', borderWidth: 2 }}
// //                                     />
// //                                 </TableCell>
// //                                 <TableCell>
// //                                     <Chip 
// //                                         label={appointment.status} 
// //                                         color={getStatusColor(appointment.status)} 
// //                                         size="small"
// //                                         sx={{ minWidth: 80 }}
// //                                     />
// //                                 </TableCell>
// //                                 <TableCell>
// //                                     <Chip 
// //                                         label={appointment.paymentStatus} 
// //                                         color={getPaymentColor(appointment.paymentStatus)} 
// //                                         size="small"
// //                                         sx={{ minWidth: 80 }}
// //                                     />
// //                                 </TableCell>
// //                                 <TableCell>
// //                                     <Button 
// //                                         onClick={() => handleCardClick(appointment.id)} 
// //                                         variant="contained"
// //                                         size="small"
// //                                         startIcon={<ViewDetailsIcon />}
// //                                         sx={{ 
// //                                             backgroundColor: '#1976d2',
// //                                             fontWeight: 'bold',
// //                                             fontSize: '0.75rem',
// //                                             px: 2,
// //                                             '&:hover': {
// //                                                 backgroundColor: '#1565c0',
// //                                                 boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)'
// //                                             }
// //                                         }}
// //                                     >
// //                                         Details
// //                                     </Button>
// //                                 </TableCell>
// //                             </TableRow>
// //                         ))}
// //                     </TableBody>
// //                 </Table>
// //             </TableContainer>
// //         );
// //     };

// //     const renderContent = () => {
// //         if (loading) {
// //             return (
// //                 <Box sx={{ 
// //                     display: 'flex', 
// //                     flexDirection: 'column',
// //                     justifyContent: 'center', 
// //                     alignItems: 'center', 
// //                     minHeight: '60vh',
// //                     textAlign: 'center'
// //                 }}>
// //                     <CircularProgress size={60} thickness={4} sx={{ color: '#1976d2', mb: 2 }} />
// //                     <Typography variant="h6" color="primary">
// //                         Loading Appointments...
// //                     </Typography>
// //                     <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
// //                         Please wait while we fetch your appointment data
// //                     </Typography>
// //                 </Box>
// //             );
// //         }

// //         if (showDetails) {
// //             return (
// //                 <Box>
// //                     <Button 
// //                         onClick={handleBackToAppointments} 
// //                         variant="outlined" 
// //                         startIcon={<ArrowBackIcon />}
// //                         sx={{ 
// //                             mb: 3,
// //                             borderColor: '#1976d2',
// //                             color: '#1976d2',
// //                             fontWeight: 'bold',
// //                             '&:hover': {
// //                                 borderColor: '#1565c0',
// //                                 backgroundColor: 'rgba(25, 118, 210, 0.04)'
// //                             }
// //                         }}
// //                     >
// //                         Back to Appointments
// //                     </Button>
// //                     <PatientDetails
// //                         appointmentId={selectedAppointmentId}
// //                         doctorId={doctorId}
// //                     />
// //                 </Box>
// //             );
// //         } else {
// //             return (
// //                 <>
// //                     {/* Header Section */}
// //                     <Box sx={{ 
// //                         mb: 4,
// //                         textAlign: isMobile ? 'center' : 'left'
// //                     }}>
// //                         <Typography 
// //                             variant={isMobile ? "h5" : "h4"} 
// //                             sx={{ 
// //                                 color: '#1976d2',
// //                                 fontWeight: 'bold',
// //                                 mb: 1
// //                             }}
// //                         >
// //                             📅 Appointment Management
// //                         </Typography>
// //                         <Typography variant="body1" color="textSecondary">
// //                             Manage and view all patient appointments
// //                         </Typography>
// //                     </Box>

// //                     {/* Statistics Summary */}
// //                     {appointments.length > 0 && (
// //                         <Paper 
// //                             elevation={0}
// //                             sx={{ 
// //                                 mb: 4, 
// //                                 p: { xs: 2, sm: 3 }, 
// //                                 backgroundColor: '#f8fbff', 
// //                                 borderRadius: 3,
// //                                 border: '1px solid #e0f2ff'
// //                             }}
// //                         >
// //                             <Typography variant="h6" sx={{ color: '#1976d2', mb: 3, fontWeight: 'medium' }}>
// //                                 📊 Appointment Overview
// //                             </Typography>
// //                             <Grid container spacing={2}>
// //                                 {[
// //                                     { label: 'Total Appointments', value: appointments.length, color: '#1976d2', bg: '#e3f2fd' },
// //                                     { label: 'Pending', value: appointments.filter(a => a.status === 'Pending').length, color: '#ff9800', bg: '#fff3e0' },
// //                                     { label: 'Confirmed', value: appointments.filter(a => a.status === 'Confirmed').length, color: '#1976d2', bg: '#e3f2fd' },
// //                                     { label: 'Completed', value: appointments.filter(a => a.status === 'Completed').length, color: '#4caf50', bg: '#e8f5e9' },
// //                                     { label: 'Today', value: appointments.filter(a => formatAppointmentDate(a.date) === formatAppointmentDate(new Date().toISOString())).length, color: '#9c27b0', bg: '#f3e5f5' },
// //                                     { label: 'This Week', value: appointments.length, color: '#009688', bg: '#e0f2f1' }
// //                                 ].map((stat, index) => (
// //                                     <Grid item xs={6} sm={4} md={2} key={index}>
// //                                         <Box sx={{ 
// //                                             textAlign: 'center',
// //                                             p: 2,
// //                                             backgroundColor: stat.bg,
// //                                             borderRadius: 2,
// //                                             height: '100%',
// //                                             display: 'flex',
// //                                             flexDirection: 'column',
// //                                             justifyContent: 'center'
// //                                         }}>
// //                                             <Typography variant="caption" color="textSecondary" sx={{ mb: 0.5, fontSize: '0.75rem' }}>
// //                                                 {stat.label}
// //                                             </Typography>
// //                                             <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: stat.color, fontWeight: 'bold' }}>
// //                                                 {stat.value}
// //                                             </Typography>
// //                                         </Box>
// //                                     </Grid>
// //                                 ))}
// //                             </Grid>
// //                         </Paper>
// //                     )}

// //                     {/* Search and Filter Section */}
// //                     <Paper 
// //                         elevation={0}
// //                         sx={{ 
// //                             mb: 3, 
// //                             p: { xs: 2, sm: 3 }, 
// //                             backgroundColor: 'white',
// //                             borderRadius: 3,
// //                             border: '1px solid #e0e0e0'
// //                         }}
// //                     >
// //                         <Grid container spacing={2} alignItems="center">
// //                             <Grid item xs={12} md={6}>
// //                                 <TextField
// //                                     fullWidth
// //                                     label="🔍 Search appointments..."
// //                                     variant="outlined"
// //                                     value={searchTerm}
// //                                     onChange={handleSearch}
// //                                     InputProps={{
// //                                         startAdornment: <SearchIcon sx={{ mr: 1, color: '#1976d2' }} />,
// //                                     }}
// //                                     placeholder="Search by patient name, date, or symptoms"
// //                                     sx={{
// //                                         '& .MuiOutlinedInput-root': {
// //                                             borderRadius: 2,
// //                                             '&.Mui-focused fieldset': {
// //                                                 borderColor: '#1976d2',
// //                                                 borderWidth: 2
// //                                             }
// //                                         },
// //                                         '& .MuiInputLabel-root.Mui-focused': {
// //                                             color: '#1976d2'
// //                                         }
// //                                     }}
// //                                 />
// //                             </Grid>
// //                             <Grid item xs={12} md={6}>
// //                                 <Box sx={{ 
// //                                     display: 'flex', 
// //                                     gap: 2,
// //                                     justifyContent: isMobile ? 'center' : 'flex-end'
// //                                 }}>
// //                                     <Chip 
// //                                         label={`Total: ${appointments.length}`}
// //                                         color="primary"
// //                                         variant="outlined"
// //                                         sx={{ fontWeight: 'bold' }}
// //                                     />
// //                                     <Chip 
// //                                         label={`Pending: ${appointments.filter(a => a.status === 'Pending').length}`}
// //                                         color="warning"
// //                                         variant="outlined"
// //                                         sx={{ fontWeight: 'bold' }}
// //                                     />
// //                                     <Chip 
// //                                         label={`Today: ${appointments.filter(a => formatAppointmentDate(a.date) === formatAppointmentDate(new Date().toISOString())).length}`}
// //                                         color="success"
// //                                         variant="outlined"
// //                                         sx={{ fontWeight: 'bold' }}
// //                                     />
// //                                 </Box>
// //                             </Grid>
// //                         </Grid>
// //                     </Paper>

// //                     {/* Data Quality Alert */}
// //                     {appointments.length > 0 && appointments.filter(a => a.patientName === 'Not provided').length > 0 && (
// //                         <Alert 
// //                             severity="warning" 
// //                             sx={{ 
// //                                 mb: 3, 
// //                                 borderRadius: 2,
// //                                 '& .MuiAlert-icon': { fontSize: '1.5rem' }
// //                             }}
// //                         >
// //                             <strong>⚠️ Data Quality Notice:</strong> {appointments.filter(a => a.patientName === 'Not provided').length} 
// //                             appointment(s) have incomplete patient information. Please verify these records.
// //                         </Alert>
// //                     )}

// //                     {/* Appointments Table/Cards */}
// //                     <Paper 
// //                         elevation={0}
// //                         sx={{ 
// //                             p: { xs: 2, sm: 3 }, 
// //                             backgroundColor: 'white',
// //                             borderRadius: 3,
// //                             border: '1px solid #e0e0e0',
// //                             minHeight: '400px'
// //                         }}
// //                     >
// //                         <Box sx={{ 
// //                             display: 'flex', 
// //                             justifyContent: 'space-between', 
// //                             alignItems: 'center',
// //                             mb: 3,
// //                             flexDirection: isMobile ? 'column' : 'row',
// //                             gap: isMobile ? 2 : 0
// //                         }}>
// //                             <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
// //                                 📋 All Appointments ({appointments.length})
// //                             </Typography>
// //                             <Typography variant="body2" color="textSecondary">
// //                                 {isMobile ? 'Swipe to see more →' : 'Scroll horizontally to see all columns →'}
// //                             </Typography>
// //                         </Box>
                        
// //                         {renderAppointmentsByDate()}
// //                     </Paper>
// //                 </>
// //             );
// //         }
// //     };

// //     return (
// //         <Box sx={{ 
// //             minHeight: '100vh',
// //             backgroundColor: '#f8fafc'
// //         }}>
// //             {renderContent()}
// //         </Box>
// //     );
// // };

// // const Appointment = () => {
// //     const { id } = useParams();
// //     const theme = useTheme();
// //     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// //     const [mobileOpen, setMobileOpen] = useState(false);

// //     const handleDrawerToggle = () => {
// //         setMobileOpen(!mobileOpen);
// //     };

// //     return (
// //         <Box sx={{ 
// //             display: 'flex',
// //             minHeight: '100vh',
// //             backgroundColor: '#f8fafc'
// //         }}>
// //             {/* Mobile App Bar */}
// //             {isMobile && (
// //                 <AppBar
// //                     position="fixed"
// //                     sx={{
// //                         width: '100%',
// //                         backgroundColor: '#1976d2',
// //                         zIndex: theme.zIndex.drawer + 1
// //                     }}
// //                 >
// //                     <Toolbar>
// //                         <IconButton
// //                             color="inherit"
// //                             aria-label="open drawer"
// //                             edge="start"
// //                             onClick={handleDrawerToggle}
// //                             sx={{ mr: 2 }}
// //                         >
// //                             <MenuIcon />
// //                         </IconButton>
// //                         <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
// //                             Doctor Portal
// //                         </Typography>
// //                     </Toolbar>
// //                 </AppBar>
// //             )}

// //             {/* Side Navigation */}
// //             <Drawer
// //                 variant={isMobile ? "temporary" : "permanent"}
// //                 open={isMobile ? mobileOpen : true}
// //                 onClose={handleDrawerToggle}
// //                 sx={{
// //                     width: drawerWidth,
// //                     flexShrink: 0,
// //                     '& .MuiDrawer-paper': {
// //                         width: drawerWidth,
// //                         boxSizing: 'border-box',
// //                         borderRight: '1px solid #e0e0e0',
// //                         backgroundColor: '#ffffff'
// //                     },
// //                 }}
// //             >
// //                 <SideNav id={id} onClose={handleDrawerToggle} />
// //             </Drawer>

// //             {/* Main Content */}
// //             <Main open={!isMobile} sx={{ 
// //                 flexGrow: 1,
// //                 p: { xs: 2, sm: 3, md: 4 },
// //                 width: { sm: `calc(100% - ${drawerWidth}px)` },
// //                 maxWidth: '100%',
// //                 overflow: 'auto'
// //             }}>
// //                 {isMobile && <Toolbar />} {/* Spacer for mobile app bar */}
                
// //                 {/* Main Content Container */}
// //                 <Container 
// //                     maxWidth="xl" 
// //                     sx={{ 
// //                         p: 0,
// //                         width: '100%',
// //                         maxWidth: '100% !important'
// //                     }}
// //                 >
// //                     <DoctorDashboard doctorId={id} />
// //                 </Container>
// //             </Main>
// //         </Box>
// //     );
// // };

// // export default withRouter(Appointment);


// import React, { useEffect, useState } from 'react';
// import { styled } from '@mui/material/styles';
// import SideNav from '../SideNav';
// import { useParams } from 'react-router-dom';
// import {
//     Box,
//     Typography,
//     Paper,
//     TextField,
//     Button,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Chip,
//     Alert,
//     Container,
//     CircularProgress,
//     useTheme,
//     useMediaQuery,
//     Drawer,
//     IconButton,
//     Stack,
//     Card,
//     CardContent,
//     Grid,
//     AppBar,
//     Toolbar
// } from '@mui/material';
// import { getDatabase, ref, onValue } from 'firebase/database';
// import { withRouter } from 'react-router-dom';
// import PatientDetails from './PatientDetails';
// import MenuIcon from '@mui/icons-material/Menu';
// import SearchIcon from '@mui/icons-material/Search';
// import ViewDetailsIcon from '@mui/icons-material/Visibility';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// const drawerWidth = 240;

// const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
//     ({ theme, open }) => ({
//         flexGrow: 1,
//         padding: theme.spacing(3),
//         transition: theme.transitions.create('margin', {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen,
//         }),
//         marginLeft: `-${drawerWidth}px`,
//         ...(open && {
//             transition: theme.transitions.create('margin', {
//                 easing: theme.transitions.easing.easeOut,
//                 duration: theme.transitions.duration.enteringScreen,
//             }),
//             marginLeft: 0,
//         }),
//         [theme.breakpoints.down('sm')]: {
//             padding: theme.spacing(2),
//             marginLeft: 0,
//             width: '100%',
//         },
//     }),
// );

// const DrawerHeader = styled('div')(({ theme }) => ({
//     display: 'flex',
//     alignItems: 'center',
//     padding: theme.spacing(0, 1),
//     ...theme.mixins.toolbar,
//     justifyContent: 'flex-end',
// }));

// const DoctorDashboard = ({ doctorId, history }) => {
//     const [appointments, setAppointments] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
//     const [showDetails, setShowDetails] = useState(false);
//     const [loading, setLoading] = useState(true);
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(theme.breakpoints.down('md'));

//     useEffect(() => {
//         console.log("📋 Fetching appointments for doctor:", doctorId);

//         const fetchAppointments = async () => {
//             try {
//                 const appointmentsRef = ref(
//                     getDatabase(),
//                     `doctor/${doctorId}/appointments`
//                 );

//                 onValue(appointmentsRef, (snapshot) => {
//                     const appointmentsArray = [];

//                     if (snapshot.exists()) {
//                         snapshot.forEach((childSnapshot) => {
//                             const appointmentId = childSnapshot.key;
//                             const appointmentData = childSnapshot.val();

//                             appointmentsArray.push({
//                                 id: appointmentId,
//                                 appointmentId: appointmentData.appointmentId || appointmentId,
//                                 patientName: appointmentData.patientName || 'Not provided',
//                                 patientAge: appointmentData.patientAge || 'N/A',
//                                 patientEmail: appointmentData.patientEmail || 'Not provided',
//                                 patientPhone: appointmentData.patientPhone || appointmentData.patientMobile || 'Not provided',
//                                 patientID: appointmentData.patientID || 'N/A',
//                                 date: appointmentData.date || 'Not provided',
//                                 timeSlot: appointmentData.timeSlot || 'Not specified',
//                                 healthIssues: appointmentData.healthIssues || 'Not provided',
//                                 symptoms: appointmentData.symptoms || appointmentData.healthIssues || appointmentData.description || 'Not provided',
//                                 description: appointmentData.description || 'Not provided',
//                                 medicalHistory: appointmentData.medicalHistory || 'None',
//                                 currentMedications: appointmentData.currentMedications || 'None',
//                                 status: appointmentData.status || 'Pending',
//                                 paymentStatus: appointmentData.paymentStatus || appointmentData.payment || 'Pending',
//                                 paymentMethod: appointmentData.paymentMethod || 'Not specified',
//                                 doctorName: appointmentData.doctorName || 'Doctor',
//                                 doctorUID: appointmentData.doctorUID || appointmentData.doctorId,
//                                 clinicName: appointmentData.clinicName || "Doctor's Clinic",
//                                 bookingDate: appointmentData.bookingDate || appointmentData.createdAt,
//                                 prescription: appointmentData.prescription || '',
//                                 prescriptionDate: appointmentData.prescriptionDate,
//                                 completedAt: appointmentData.completedAt
//                             });
//                         });

//                         console.log("✅ Loaded appointments:", appointmentsArray.length);
//                     } else {
//                         console.log("❌ No appointments found in database");
//                     }

//                     setAppointments(appointmentsArray);
//                     setLoading(false);
//                 });
//             } catch (error) {
//                 console.error('❌ Error fetching doctor appointments:', error);
//                 setLoading(false);
//             }
//         };

//         fetchAppointments();
//     }, [doctorId]);

//     const handleCardClick = (appointmentId) => {
//         console.log("👁️ Viewing appointment:", appointmentId);
//         setSelectedAppointmentId(appointmentId);
//         setShowDetails(true);
//     };

//     const handleSearch = (e) => {
//         setSearchTerm(e.target.value.toLowerCase());
//     };

//     const handleBackToAppointments = () => {
//         setShowDetails(false);
//         setSelectedAppointmentId(null);
//     };

//     const formatAppointmentDate = (date) => {
//         if (!date || date === 'Not provided') return 'N/A';
//         if (date.includes('/')) return date;
//         try {
//             const dateObj = new Date(date);
//             if (!isNaN(dateObj.getTime())) {
//                 return dateObj.toLocaleDateString('en-US', {
//                     month: '2-digit',
//                     day: '2-digit',
//                     year: 'numeric'
//                 });
//             }
//         } catch (error) {
//             console.error('Error formatting date:', error);
//         }
//         return date;
//     };

//     const convertTo24HourFormat = (timeSlot) => {
//         if (!timeSlot || timeSlot === 'Not specified') return '00:00';
//         try {
//             const [time, period] = timeSlot.split(' ');
//             let [hours, minutes] = time.split(':');
//             if (period === 'PM' && hours !== '12') {
//                 hours = String(Number(hours) + 12);
//             } else if (period === 'AM' && hours === '12') {
//                 hours = '00';
//             }
//             hours = hours.padStart(2, '0');
//             minutes = minutes.padStart(2, '0');
//             return `${hours}:${minutes}`;
//         } catch (error) {
//             return '00:00';
//         }
//     };

//     const getStatusColor = (status) => {
//         switch (status?.toLowerCase()) {
//             case 'completed': return 'success';
//             case 'confirmed': return 'primary';
//             case 'pending': return 'warning';
//             case 'cancelled': return 'error';
//             default: return 'default';
//         }
//     };

//     const getPaymentColor = (paymentStatus) => {
//         return paymentStatus?.toLowerCase() === 'pending' ? 'warning' : 'success';
//     };

//     const renderMobileAppointmentCard = (appointment, index) => {
//         return (
//             <Card
//                 key={appointment.id}
//                 sx={{
//                     mb: 2,
//                     borderLeft: `4px solid ${getStatusColor(appointment.status) === 'success' ? '#4caf50' :
//                         getStatusColor(appointment.status) === 'primary' ? '#1976d2' :
//                             getStatusColor(appointment.status) === 'warning' ? '#ff9800' : '#f44336'}`,
//                     transition: 'transform 0.2s',
//                     '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 }
//                 }}
//             >
//                 <CardContent sx={{ p: 2 }}>
//                     <Stack spacing={1.5}>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                             <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
//                                 {appointment.patientName}
//                             </Typography>
//                             <Chip
//                                 label={appointment.status}
//                                 color={getStatusColor(appointment.status)}
//                                 size="small"
//                                 sx={{ fontSize: '0.75rem' }}
//                             />
//                         </Box>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                             <Typography variant="body2" color="textSecondary">
//                                 Age: {appointment.patientAge} {appointment.patientAge !== 'N/A' ? 'yrs' : ''}
//                             </Typography>
//                             <Typography variant="body2" color="textSecondary">
//                                 ID: {appointment.patientID}
//                             </Typography>
//                         </Box>
//                         <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             📱 {appointment.patientPhone}
//                         </Typography>
//                         <Typography variant="body2" sx={{
//                             color: '#666',
//                             display: '-webkit-box',
//                             WebkitLineClamp: 2,
//                             WebkitBoxOrient: 'vertical',
//                             overflow: 'hidden',
//                             fontSize: '0.875rem'
//                         }}>
//                             {appointment.symptoms}
//                         </Typography>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <Box>
//                                 <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
//                                     {formatAppointmentDate(appointment.date)}
//                                 </Typography>
//                                 <Typography variant="caption" color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                                     🕐 {appointment.timeSlot}
//                                 </Typography>
//                             </Box>
//                             <Button
//                                 onClick={() => handleCardClick(appointment.id)}
//                                 variant="contained"
//                                 size="small"
//                                 startIcon={<ViewDetailsIcon />}
//                                 sx={{
//                                     backgroundColor: '#1976d2',
//                                     fontSize: '0.75rem',
//                                     '&:hover': { backgroundColor: '#1565c0' }
//                                 }}
//                             >
//                                 View
//                             </Button>
//                         </Box>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <Chip
//                                 label={appointment.paymentStatus}
//                                 color={getPaymentColor(appointment.paymentStatus)}
//                                 size="small"
//                                 sx={{ fontSize: '0.75rem' }}
//                             />
//                             <Typography variant="caption" color="textSecondary">
//                                 #{index + 1}
//                             </Typography>
//                         </Box>
//                     </Stack>
//                 </CardContent>
//             </Card>
//         );
//     };

//     const renderAppointmentsByDate = () => {
//         const filteredAppointments = appointments.filter((appointment) => {
//             if (!searchTerm) return true;
//             const searchLower = searchTerm.toLowerCase();
//             const formattedDate = formatAppointmentDate(appointment.date).toLowerCase();
//             const patientName = (appointment.patientName || '').toLowerCase();
//             const symptoms = (appointment.symptoms || '').toLowerCase();
//             return formattedDate.includes(searchLower) ||
//                 patientName.includes(searchLower) ||
//                 symptoms.includes(searchLower);
//         });

//         filteredAppointments.sort((a, b) => {
//             const dateCompare = new Date(a.date) - new Date(b.date);
//             if (dateCompare !== 0) return dateCompare;
//             const timeA = convertTo24HourFormat(a.timeSlot);
//             const timeB = convertTo24HourFormat(b.timeSlot);
//             return timeA.localeCompare(timeB);
//         });

//         if (filteredAppointments.length === 0) {
//             return (
//                 <Box sx={{
//                     textAlign: 'center',
//                     py: 8,
//                     backgroundColor: '#fafafa',
//                     borderRadius: 2,
//                     border: '1px dashed #ddd'
//                 }}>
//                     <Typography variant="h6" color="textSecondary" gutterBottom>
//                         📅 No Appointments Found
//                     </Typography>
//                     <Typography variant="body2" color="textSecondary">
//                         {searchTerm ? 'Try adjusting your search terms' : 'No appointments scheduled yet'}
//                     </Typography>
//                 </Box>
//             );
//         }

//         if (isMobile) {
//             return (
//                 <Box sx={{ mt: 2 }}>
//                     {filteredAppointments.map((appointment, index) =>
//                         renderMobileAppointmentCard(appointment, index)
//                     )}
//                 </Box>
//             );
//         }

//         return (
//             <TableContainer
//                 component={Paper}
//                 sx={{
//                     borderRadius: 2,
//                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                     overflowX: 'auto',
//                     maxWidth: '100%',
//                     mx: 'auto'
//                 }}
//             >
//                 <Table sx={{ minWidth: isTablet ? 800 : 1200 }}>
//                     <TableHead sx={{ backgroundColor: '#1976d2' }}>
//                         <TableRow>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 50 }}>#</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 150 }}>Patient</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 80 }}>Age</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 180 }}>Contact</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 200 }}>Symptoms</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 120 }}>Date</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 120 }}>Time</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 100 }}>Status</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 100 }}>Payment</TableCell>
//                             <TableCell sx={{ color: 'white', fontWeight: 'bold', minWidth: 120 }}>Action</TableCell>
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {filteredAppointments.map((appointment, index) => (
//                             <TableRow
//                                 key={appointment.id}
//                                 hover
//                                 sx={{
//                                     '&:hover': { backgroundColor: '#f5f9ff' },
//                                     backgroundColor: index % 2 === 0 ? 'white' : '#fafafa',
//                                     transition: 'background-color 0.2s'
//                                 }}
//                             >
//                                 <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>{index + 1}</TableCell>
//                                 <TableCell>
//                                     <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
//                                         {appointment.patientName}
//                                     </Typography>
//                                     <Typography variant="caption" color="textSecondary">
//                                         ID: {appointment.patientID}
//                                     </Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                     <Chip
//                                         label={`${appointment.patientAge} ${appointment.patientAge !== 'N/A' ? 'yrs' : ''}`}
//                                         size="small"
//                                         variant="outlined"
//                                         sx={{ borderColor: '#1976d2', color: '#1976d2' }}
//                                     />
//                                 </TableCell>
//                                 <TableCell>
//                                     <Stack spacing={0.5}>
//                                         <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                                             📱 {appointment.patientPhone}
//                                         </Typography>
//                                         <Typography variant="caption" color="textSecondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                                             📧 {appointment.patientEmail}
//                                         </Typography>
//                                     </Stack>
//                                 </TableCell>
//                                 <TableCell sx={{ maxWidth: '200px' }}>
//                                     <Typography variant="body2" sx={{
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis',
//                                         whiteSpace: 'nowrap'
//                                     }}>
//                                         {appointment.symptoms}
//                                     </Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                     <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                                         {formatAppointmentDate(appointment.date)}
//                                     </Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                     <Chip
//                                         label={appointment.timeSlot}
//                                         color="primary"
//                                         size="small"
//                                         variant="outlined"
//                                         sx={{ fontWeight: 'bold', borderWidth: 2 }}
//                                     />
//                                 </TableCell>
//                                 <TableCell>
//                                     <Chip
//                                         label={appointment.status}
//                                         color={getStatusColor(appointment.status)}
//                                         size="small"
//                                         sx={{ minWidth: 80 }}
//                                     />
//                                 </TableCell>
//                                 <TableCell>
//                                     <Chip
//                                         label={appointment.paymentStatus}
//                                         color={getPaymentColor(appointment.paymentStatus)}
//                                         size="small"
//                                         sx={{ minWidth: 80 }}
//                                     />
//                                 </TableCell>
//                                 <TableCell>
//                                     <Button
//                                         onClick={() => handleCardClick(appointment.id)}
//                                         variant="contained"
//                                         size="small"
//                                         startIcon={<ViewDetailsIcon />}
//                                         sx={{
//                                             backgroundColor: '#1976d2',
//                                             fontWeight: 'bold',
//                                             fontSize: '0.75rem',
//                                             px: 2,
//                                             '&:hover': {
//                                                 backgroundColor: '#1565c0',
//                                                 boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)'
//                                             }
//                                         }}
//                                     >
//                                         Details
//                                     </Button>
//                                 </TableCell>
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//         );
//     };

//     const renderContent = () => {
//         if (loading) {
//             return (
//                 <Box sx={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     minHeight: '60vh',
//                     textAlign: 'center'
//                 }}>
//                     <CircularProgress size={60} thickness={4} sx={{ color: '#1976d2', mb: 2 }} />
//                     <Typography variant="h6" color="primary">Loading Appointments...</Typography>
//                     <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
//                         Please wait while we fetch your appointment data
//                     </Typography>
//                 </Box>
//             );
//         }

//         if (showDetails) {
//             return (
//                 <Box>
//                     <Button
//                         onClick={handleBackToAppointments}
//                         variant="outlined"
//                         startIcon={<ArrowBackIcon />}
//                         sx={{
//                             mb: 3,
//                             borderColor: '#1976d2',
//                             color: '#1976d2',
//                             fontWeight: 'bold',
//                             '&:hover': {
//                                 borderColor: '#1565c0',
//                                 backgroundColor: 'rgba(25, 118, 210, 0.04)'
//                             }
//                         }}
//                     >
//                         Back to Appointments
//                     </Button>
//                     <PatientDetails
//                         appointmentId={selectedAppointmentId}
//                         doctorId={doctorId}
//                         onAppointmentCompleted={handleBackToAppointments}
//                     />
//                 </Box>
//             );
//         } else {
//             return (
//                 <>
//                     <Box sx={{ mb: 4, textAlign: isMobile ? 'center' : 'left' }}>
//                         <Typography
//                             variant={isMobile ? "h5" : "h4"}
//                             sx={{ color: '#1976d2', fontWeight: 'bold', mb: 1 }}
//                         >
//                             📅 Appointment Management
//                         </Typography>
//                         <Typography variant="body1" color="textSecondary">
//                             Manage and view all patient appointments
//                         </Typography>
//                     </Box>

//                     {appointments.length > 0 && (
//                         <Paper
//                             elevation={0}
//                             sx={{
//                                 mb: 4,
//                                 p: { xs: 2, sm: 3 },
//                                 backgroundColor: '#f8fbff',
//                                 borderRadius: 3,
//                                 border: '1px solid #e0f2ff'
//                             }}
//                         >
//                             <Typography variant="h6" sx={{ color: '#1976d2', mb: 3, fontWeight: 'medium' }}>
//                                 📊 Appointment Overview
//                             </Typography>
//                             <Grid container spacing={2}>
//                                 {[
//                                     { label: 'Total Appointments', value: appointments.length, color: '#1976d2', bg: '#e3f2fd' },
//                                     { label: 'Pending', value: appointments.filter(a => a.status?.toLowerCase() === 'pending').length, color: '#ff9800', bg: '#fff3e0' },
//                                     { label: 'Confirmed', value: appointments.filter(a => a.status?.toLowerCase() === 'confirmed').length, color: '#1976d2', bg: '#e3f2fd' },
//                                     { label: 'Completed', value: appointments.filter(a => a.status?.toLowerCase() === 'completed').length, color: '#4caf50', bg: '#e8f5e9' },
//                                     { label: 'Today', value: appointments.filter(a => formatAppointmentDate(a.date) === formatAppointmentDate(new Date().toISOString())).length, color: '#9c27b0', bg: '#f3e5f5' },
//                                     { label: 'Cancelled', value: appointments.filter(a => a.status?.toLowerCase() === 'cancelled').length, color: '#f44336', bg: '#ffebee' }
//                                 ].map((stat, index) => (
//                                     <Grid item xs={6} sm={4} md={2} key={index}>
//                                         <Box sx={{
//                                             textAlign: 'center',
//                                             p: 2,
//                                             backgroundColor: stat.bg,
//                                             borderRadius: 2,
//                                             height: '100%',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             justifyContent: 'center'
//                                         }}>
//                                             <Typography variant="caption" color="textSecondary" sx={{ mb: 0.5, fontSize: '0.75rem' }}>
//                                                 {stat.label}
//                                             </Typography>
//                                             <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: stat.color, fontWeight: 'bold' }}>
//                                                 {stat.value}
//                                             </Typography>
//                                         </Box>
//                                     </Grid>
//                                 ))}
//                             </Grid>
//                         </Paper>
//                     )}

//                     <Paper
//                         elevation={0}
//                         sx={{
//                             mb: 3,
//                             p: { xs: 2, sm: 3 },
//                             backgroundColor: 'white',
//                             borderRadius: 3,
//                             border: '1px solid #e0e0e0'
//                         }}
//                     >
//                         <Grid container spacing={2} alignItems="center">
//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="🔍 Search appointments..."
//                                     variant="outlined"
//                                     value={searchTerm}
//                                     onChange={handleSearch}
//                                     InputProps={{
//                                         startAdornment: <SearchIcon sx={{ mr: 1, color: '#1976d2' }} />,
//                                     }}
//                                     placeholder="Search by patient name, date, or symptoms"
//                                     sx={{
//                                         '& .MuiOutlinedInput-root': {
//                                             borderRadius: 2,
//                                             '&.Mui-focused fieldset': { borderColor: '#1976d2', borderWidth: 2 }
//                                         },
//                                         '& .MuiInputLabel-root.Mui-focused': { color: '#1976d2' }
//                                     }}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <Box sx={{
//                                     display: 'flex',
//                                     gap: 2,
//                                     justifyContent: isMobile ? 'center' : 'flex-end'
//                                 }}>
//                                     <Chip label={`Total: ${appointments.length}`} color="primary" variant="outlined" sx={{ fontWeight: 'bold' }} />
//                                     <Chip label={`Pending: ${appointments.filter(a => a.status?.toLowerCase() === 'pending').length}`} color="warning" variant="outlined" sx={{ fontWeight: 'bold' }} />
//                                     <Chip label={`Today: ${appointments.filter(a => formatAppointmentDate(a.date) === formatAppointmentDate(new Date().toISOString())).length}`} color="success" variant="outlined" sx={{ fontWeight: 'bold' }} />
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </Paper>

//                     {appointments.length > 0 && appointments.filter(a => a.patientName === 'Not provided').length > 0 && (
//                         <Alert
//                             severity="warning"
//                             sx={{ mb: 3, borderRadius: 2, '& .MuiAlert-icon': { fontSize: '1.5rem' } }}
//                         >
//                             <strong>⚠️ Data Quality Notice:</strong> {appointments.filter(a => a.patientName === 'Not provided').length} appointment(s) have incomplete patient information. Please verify these records.
//                         </Alert>
//                     )}

//                     <Paper
//                         elevation={0}
//                         sx={{
//                             p: { xs: 2, sm: 3 },
//                             backgroundColor: 'white',
//                             borderRadius: 3,
//                             border: '1px solid #e0e0e0',
//                             minHeight: '400px'
//                         }}
//                     >
//                         <Box sx={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             mb: 3,
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 2 : 0
//                         }}>
//                             <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                                 📋 All Appointments ({appointments.length})
//                             </Typography>
//                             <Typography variant="body2" color="textSecondary">
//                                 {isMobile ? 'Swipe to see more →' : 'Scroll horizontally to see all columns →'}
//                             </Typography>
//                         </Box>

//                         {renderAppointmentsByDate()}
//                     </Paper>
//                 </>
//             );
//         }
//     };

//     return (
//         <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
//             {renderContent()}
//         </Box>
//     );
// };

// const Appointment = () => {
//     const { id } = useParams();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const [mobileOpen, setMobileOpen] = useState(false);

//     const handleDrawerToggle = () => {
//         setMobileOpen(!mobileOpen);
//     };

//     return (
//         <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f8fafc' }}>
//             {isMobile && (
//                 <AppBar
//                     position="fixed"
//                     sx={{ width: '100%', backgroundColor: '#1976d2', zIndex: theme.zIndex.drawer + 1 }}
//                 >
//                     <Toolbar>
//                         <IconButton
//                             color="inherit"
//                             aria-label="open drawer"
//                             edge="start"
//                             onClick={handleDrawerToggle}
//                             sx={{ mr: 2 }}
//                         >
//                             <MenuIcon />
//                         </IconButton>
//                         <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
//                             Doctor Portal
//                         </Typography>
//                     </Toolbar>
//                 </AppBar>
//             )}

//             <Drawer
//                 variant={isMobile ? "temporary" : "permanent"}
//                 open={isMobile ? mobileOpen : true}
//                 onClose={handleDrawerToggle}
//                 sx={{
//                     width: drawerWidth,
//                     flexShrink: 0,
//                     '& .MuiDrawer-paper': {
//                         width: drawerWidth,
//                         boxSizing: 'border-box',
//                         borderRight: '1px solid #e0e0e0',
//                         backgroundColor: '#ffffff'
//                     },
//                 }}
//             >
//                 <SideNav id={id} onClose={handleDrawerToggle} />
//             </Drawer>

//             <Main open={!isMobile} sx={{
//                 flexGrow: 1,
//                 p: { xs: 2, sm: 3, md: 4 },
//                 width: { sm: `calc(100% - ${drawerWidth}px)` },
//                 maxWidth: '100%',
//                 overflow: 'auto'
//             }}>
//                 {isMobile && <Toolbar />}
//                 <Container maxWidth="xl" sx={{ p: 0, width: '100%', maxWidth: '100% !important' }}>
//                     <DoctorDashboard doctorId={id} />
//                 </Container>
//             </Main>
//         </Box>
//     );
// };

// export default withRouter(Appointment);


import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import SideNav from '../SideNav';
import { useParams } from 'react-router-dom';
import {
    Box, Typography, Paper, TextField, Button, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Chip, Alert,
    Container, CircularProgress, useTheme, useMediaQuery, Drawer,
    IconButton, Stack, Card, CardContent, Grid, AppBar, Toolbar,
    Rating, Avatar, Modal, Fade, Backdrop
} from '@mui/material';
import { getDatabase, ref, onValue } from 'firebase/database';
import { withRouter } from 'react-router-dom';
import PatientDetails from './PatientDetails';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import ViewDetailsIcon from '@mui/icons-material/Visibility';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import StarIcon from '@mui/icons-material/Star';
import ReviewIcon from '@mui/icons-material/RateReview';
import CloseIcon from '@mui/icons-material/Close';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleIcon from '@mui/icons-material/People';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PendingActionsIcon from '@mui/icons-material/PendingActions';

// ─── Constants ─────────────────────────────────────────────────────
const drawerWidth = 260;
const BRAND       = '#0A6EBD';
const BRAND_DARK  = '#084E8A';
const BRAND_LIGHT = '#E8F4FF';
const GOLD        = '#F59E0B';
const GOLD_BG     = '#FFFBEB';
const SUCCESS     = '#10B981';
const DANGER      = '#EF4444';
const SURFACE     = '#F7FAFD';
const BORDER      = '#E2ECF8';

// ─── Styled Main ────────────────────────────────────────────────────
const Main = styled('main', { shouldForwardProp: (p) => p !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(4),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
            marginLeft: 0,
            width: '100%',
        },
    })
);

// ─── Stat Card ──────────────────────────────────────────────────────
const StatCard = ({ label, value, icon, color, bg }) => (
    <Box sx={{
        p: { xs: 1.5, sm: 2 },
        borderRadius: '14px',
        background: bg,
        border: `1px solid ${color}22`,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        position: 'relative',
        overflow: 'hidden',
        '&::after': {
            content: '""', position: 'absolute',
            right: -10, top: -10, width: 60, height: 60,
            borderRadius: '50%', background: `${color}18`,
        }
    }}>
        <Typography variant="caption" sx={{
            color: '#6B7280', fontWeight: 600,
            letterSpacing: '0.04em', textTransform: 'uppercase', fontSize: '0.65rem'
        }}>
            {label}
        </Typography>
        <Typography variant="h4" sx={{ color, fontWeight: 800, lineHeight: 1.1, fontSize: { xs: '1.6rem', sm: '2rem' } }}>
            {value}
        </Typography>
        <Box sx={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color, opacity: 0.3, zIndex: 1 }}>
            {icon}
        </Box>
    </Box>
);

// ─── Status badge ────────────────────────────────────────────────────
const STATUS_MAP = {
    completed: { color: SUCCESS,   bg: '#D1FAE5',   label: 'Completed' },
    confirmed: { color: BRAND,     bg: BRAND_LIGHT, label: 'Confirmed' },
    pending:   { color: '#D97706', bg: '#FEF3C7',   label: 'Pending'   },
    cancelled: { color: DANGER,    bg: '#FEE2E2',   label: 'Cancelled' },
};
const getStatusStyle = (s) =>
    STATUS_MAP[s?.toLowerCase()] || { color: '#9CA3AF', bg: '#F3F4F6', label: s || 'Unknown' };

const StatusBadge = ({ label }) => {
    const st = getStatusStyle(label);
    return (
        <Box sx={{
            display: 'inline-flex', alignItems: 'center',
            px: 1.2, py: 0.35, borderRadius: '20px',
            background: st.bg, color: st.color,
            fontWeight: 700, fontSize: '0.70rem',
            border: `1px solid ${st.color}40`,
            whiteSpace: 'nowrap',
        }}>
            {st.label}
        </Box>
    );
};

// ═══════════════════════════════════════════════════════════════════
//  MAIN DASHBOARD
// ═══════════════════════════════════════════════════════════════════
const DoctorDashboard = ({ doctorId }) => {
    const [appointments,  setAppointments]  = useState([]);
    const [searchTerm,    setSearchTerm]    = useState('');
    const [selectedId,    setSelectedId]    = useState(null);
    const [showDetails,   setShowDetails]   = useState(false);
    const [loading,       setLoading]       = useState(true);
    const [reviews,       setReviews]       = useState([]);
    const [averageRating, setAverageRating] = useState(0);
    const [openReviews,   setOpenReviews]   = useState(false);

    const theme    = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // ── Fetch appointments ────────────────────────────────────────
    useEffect(() => {
        const apptRef = ref(getDatabase(), `doctor/${doctorId}/appointments`);
        const unsub = onValue(apptRef, (snapshot) => {
            const arr = [];
            if (snapshot.exists()) {
                snapshot.forEach((child) => {
                    const d = child.val();
                    arr.push({
                        id:                 child.key,
                        appointmentId:      d.appointmentId      || child.key,
                        patientName:        d.patientName        || 'Not provided',
                        patientAge:         d.patientAge         || 'N/A',
                        patientEmail:       d.patientEmail       || 'Not provided',
                        patientPhone:       d.patientPhone       || d.patientMobile || 'Not provided',
                        patientID:          d.patientID          || 'N/A',
                        date:               d.date               || 'Not provided',
                        timeSlot:           d.timeSlot           || 'Not specified',
                        symptoms:           d.symptoms           || d.healthIssues  || d.description || 'Not provided',
                        description:        d.description        || 'Not provided',
                        medicalHistory:     d.medicalHistory     || 'None',
                        currentMedications: d.currentMedications || 'None',
                        status:             d.status             || 'Pending',
                        paymentStatus:      d.paymentStatus      || d.payment       || 'Pending',
                        paymentMethod:      d.paymentMethod      || 'Not specified',
                        doctorName:         d.doctorName         || 'Doctor',
                        doctorUID:          d.doctorUID          || d.doctorId,
                        clinicName:         d.clinicName         || "Doctor's Clinic",
                        bookingDate:        d.bookingDate        || d.createdAt,
                        prescription:       d.prescription       || '',
                        prescriptionDate:   d.prescriptionDate,
                        completedAt:        d.completedAt,
                        reviewed:           d.reviewed           || false,
                    });
                });
            }
            setAppointments(arr);
            setLoading(false);
        });
        return () => unsub();
    }, [doctorId]);

    // ── Fetch reviews (real-time) ─────────────────────────────────
    // Firebase path: reviews/{doctorId}/{reviewId}
    // Each review document: { patientName, rating (1–5), comment, date }
    useEffect(() => {
        if (!doctorId) return;
        const revRef = ref(getDatabase(), `reviews/${doctorId}`);
        const unsub = onValue(revRef, (snapshot) => {
            const list = [];
            let total = 0;
            snapshot.forEach((child) => {
                const r = { id: child.key, ...child.val() };
                list.push(r);
                total += Number(r.rating) || 0;
            });
            list.sort((a, b) => new Date(b.date) - new Date(a.date));
            setReviews(list);
            setAverageRating(list.length > 0 ? total / list.length : 0);
        });
        return () => unsub();
    }, [doctorId]);

    // ── Helpers ───────────────────────────────────────────────────
    const formatDate = (date) => {
        if (!date || date === 'Not provided') return 'N/A';
        if (date.includes('/')) return date;
        try {
            const d = new Date(date);
            if (!isNaN(d)) return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
        } catch (_) {}
        return date;
    };

    const convertTo24h = (slot) => {
        if (!slot || slot === 'Not specified') return '00:00';
        try {
            const [time, period] = slot.split(' ');
            let [h, m] = time.split(':');
            if (period === 'PM' && h !== '12') h = String(Number(h) + 12);
            else if (period === 'AM' && h === '12') h = '00';
            return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
        } catch (_) { return '00:00'; }
    };

    const todayStr = formatDate(new Date().toISOString());

    const filtered = appointments
        .filter((a) => {
            if (!searchTerm) return true;
            const s = searchTerm.toLowerCase();
            return (
                (a.patientName || '').toLowerCase().includes(s) ||
                formatDate(a.date).toLowerCase().includes(s) ||
                (a.symptoms || '').toLowerCase().includes(s)
            );
        })
        .sort((a, b) => {
            const dc = new Date(a.date) - new Date(b.date);
            return dc !== 0 ? dc : convertTo24h(a.timeSlot).localeCompare(convertTo24h(b.timeSlot));
        });

    const getRatingDist = () => {
        const d = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        reviews.forEach((r) => { if (d[r.rating] !== undefined) d[r.rating]++; });
        return d;
    };

    const handleBack = () => { setShowDetails(false); setSelectedId(null); };

    // ── Reviews Modal ─────────────────────────────────────────────
    const ReviewsModal = () => {
        const dist = getRatingDist();
        return (
            <Modal
                open={openReviews}
                onClose={() => setOpenReviews(false)}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { timeout: 400 } }}
            >
                <Fade in={openReviews}>
                    <Box sx={{
                        position: 'absolute', top: '50%', left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '92%', sm: 520, md: 600 },
                        maxHeight: '85vh', overflowY: 'auto',
                        bgcolor: '#fff', borderRadius: '20px',
                        boxShadow: '0 32px 80px rgba(0,0,0,0.18)',
                        outline: 'none',
                        '&::-webkit-scrollbar': { width: 6 },
                        '&::-webkit-scrollbar-thumb': { background: '#CBD5E1', borderRadius: 8 },
                    }}>
                        {/* Header */}
                        <Box sx={{
                            p: 3, pb: 2,
                            background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                            borderRadius: '20px 20px 0 0',
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                        }}>
                            <Box>
                                <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: '1.2rem' }}>
                                    Patient Reviews
                                </Typography>
                                <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.78rem' }}>
                                    {reviews.length} review{reviews.length !== 1 ? 's' : ''} · Live updates
                                </Typography>
                            </Box>
                            <IconButton
                                onClick={() => setOpenReviews(false)}
                                sx={{ color: '#fff', bgcolor: 'rgba(255,255,255,0.15)', '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' } }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Box sx={{ p: 3 }}>
                            {reviews.length === 0 ? (
                                <Box sx={{ textAlign: 'center', py: 8 }}>
                                    <Typography sx={{ fontSize: '3rem', mb: 1 }}>⭐</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>No Reviews Yet</Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        Patients will leave reviews after completed appointments.
                                    </Typography>
                                </Box>
                            ) : (
                                <>
                                    {/* Summary */}
                                    <Box sx={{
                                        p: 2.5, mb: 3, borderRadius: '14px',
                                        background: GOLD_BG, border: `1px solid #FDE68A`,
                                        display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap'
                                    }}>
                                        <Box sx={{ textAlign: 'center', minWidth: 80 }}>
                                            <Typography sx={{ fontSize: '3rem', fontWeight: 900, color: GOLD, lineHeight: 1 }}>
                                                {averageRating.toFixed(1)}
                                            </Typography>
                                            <Rating value={averageRating} precision={0.5} readOnly size="small" sx={{ color: GOLD }} />
                                            <Typography variant="caption" color="textSecondary">
                                                {reviews.length} review{reviews.length !== 1 ? 's' : ''}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ flex: 1, minWidth: 160 }}>
                                            {[5, 4, 3, 2, 1].map((star) => (
                                                <Box key={star} display="flex" alignItems="center" gap={1} mb={0.5}>
                                                    <Typography variant="caption" sx={{ minWidth: 28, color: '#6B7280', fontWeight: 600 }}>
                                                        {star}★
                                                    </Typography>
                                                    <Box sx={{ flex: 1, height: 7, bgcolor: '#F3F4F6', borderRadius: 4, overflow: 'hidden' }}>
                                                        <Box sx={{
                                                            height: '100%', bgcolor: GOLD, borderRadius: 4,
                                                            width: `${reviews.length > 0 ? (dist[star] / reviews.length) * 100 : 0}%`,
                                                            transition: 'width 0.6s ease'
                                                        }} />
                                                    </Box>
                                                    <Typography variant="caption" sx={{ minWidth: 18, color: '#9CA3AF' }}>
                                                        {dist[star]}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>

                                    {/* Individual cards */}
                                    <Typography sx={{ fontWeight: 700, color: '#111827', mb: 2, fontSize: '0.92rem' }}>
                                        All Reviews
                                    </Typography>
                                    {reviews.map((review) => (
                                        <Box key={review.id} sx={{
                                            p: 2.5, mb: 2, borderRadius: '14px',
                                            border: `1px solid ${BORDER}`, background: '#FAFCFF',
                                            transition: 'box-shadow 0.2s',
                                            '&:hover': { boxShadow: '0 4px 16px rgba(10,110,189,0.08)' }
                                        }}>
                                            <Box display="flex" alignItems="flex-start" gap={2}>
                                                <Avatar sx={{
                                                    bgcolor: BRAND, width: 40, height: 40,
                                                    fontWeight: 700, fontSize: '1rem',
                                                    boxShadow: '0 2px 8px rgba(10,110,189,0.3)'
                                                }}>
                                                    {review.patientName?.charAt(0)?.toUpperCase() || 'P'}
                                                </Avatar>
                                                <Box flex={1}>
                                                    <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={1}>
                                                        <Box>
                                                            <Typography sx={{ fontWeight: 700, color: '#111827', fontSize: '0.88rem' }}>
                                                                {review.patientName || 'Anonymous'}
                                                            </Typography>
                                                            <Rating value={review.rating} readOnly size="small" sx={{ color: GOLD }} />
                                                        </Box>
                                                        <Typography variant="caption" sx={{ color: '#9CA3AF', mt: 0.5 }}>
                                                            {review.date
                                                                ? new Date(review.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                                                                : ''}
                                                        </Typography>
                                                    </Box>
                                                    {review.comment && (
                                                        <Typography variant="body2" sx={{
                                                            mt: 1, color: '#4B5563', lineHeight: 1.6,
                                                            fontStyle: 'italic',
                                                            borderLeft: `3px solid ${GOLD}`,
                                                            pl: 1.5, background: GOLD_BG,
                                                            borderRadius: '0 8px 8px 0', py: 0.75, pr: 1
                                                        }}>
                                                            "{review.comment}"
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>
                                    ))}
                                </>
                            )}
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        );
    };

    // ── Mobile card ───────────────────────────────────────────────
    const MobileCard = ({ appointment, index }) => {
        const s = getStatusStyle(appointment.status);
        return (
            <Card sx={{
                mb: 2,
                borderLeft: `4px solid ${s.color}`,
                transition: 'transform 0.2s',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 }
            }}>
                <CardContent sx={{ p: 2 }}>
                    <Stack spacing={1.5}>
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                            <Box>
                                <Typography sx={{ fontWeight: 700, color: BRAND, fontSize: '0.95rem' }}>
                                    {appointment.patientName}
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    ID: {appointment.patientID}
                                </Typography>
                            </Box>
                            <StatusBadge label={appointment.status} />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="textSecondary">
                                Age: {appointment.patientAge}{appointment.patientAge !== 'N/A' ? ' yrs' : ''}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">#{index + 1}</Typography>
                        </Box>
                        <Typography variant="body2">📱 {appointment.patientPhone}</Typography>
                        <Typography variant="body2" sx={{
                            color: '#666', display: '-webkit-box',
                            WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'
                        }}>
                            {appointment.symptoms}
                        </Typography>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                    {formatDate(appointment.date)}
                                </Typography>
                                <Typography variant="caption" sx={{ color: BRAND }}>
                                    🕐 {appointment.timeSlot}
                                </Typography>
                            </Box>
                            <Button
                                onClick={() => { setSelectedId(appointment.id); setShowDetails(true); }}
                                variant="contained"
                                size="small"
                                startIcon={<ViewDetailsIcon />}
                                sx={{ backgroundColor: BRAND, fontSize: '0.75rem', '&:hover': { backgroundColor: BRAND_DARK } }}
                            >
                                View
                            </Button>
                        </Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Chip
                                label={appointment.paymentStatus}
                                color={appointment.paymentStatus?.toLowerCase() === 'pending' ? 'warning' : 'success'}
                                size="small"
                                sx={{ fontSize: '0.72rem' }}
                            />
                            {appointment.reviewed && (
                                <Box sx={{
                                    px: 1.2, py: 0.3, borderRadius: '20px',
                                    background: GOLD_BG, color: GOLD,
                                    fontWeight: 700, fontSize: '0.70rem',
                                    border: `1px solid ${GOLD}40`,
                                    display: 'inline-flex', alignItems: 'center', gap: 0.4
                                }}>
                                    <StarIcon sx={{ fontSize: 11 }} /> Reviewed
                                </Box>
                            )}
                        </Box>
                    </Stack>
                </CardContent>
            </Card>
        );
    };

    // ── Loading ───────────────────────────────────────────────────
    if (loading) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', textAlign: 'center' }}>
                <CircularProgress size={60} thickness={4} sx={{ color: BRAND, mb: 2 }} />
                <Typography variant="h6" sx={{ color: BRAND, fontWeight: 700 }}>Loading Appointments...</Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    Please wait while we fetch your appointment data
                </Typography>
            </Box>
        );
    }

    // ── Patient details view ──────────────────────────────────────
    if (showDetails) {
        return (
            <Box>
                <Button
                    onClick={handleBack}
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    sx={{
                        mb: 3, borderColor: BRAND, color: BRAND, fontWeight: 'bold',
                        '&:hover': { borderColor: BRAND_DARK, backgroundColor: 'rgba(10,110,189,0.04)' }
                    }}
                >
                    Back to Appointments
                </Button>
                <PatientDetails
                    appointmentId={selectedId}
                    doctorId={doctorId}
                    onAppointmentCompleted={handleBack}
                />
            </Box>
        );
    }

    // ── Main view ─────────────────────────────────────────────────
    const todayCount = appointments.filter(a => formatDate(a.date) === todayStr).length;

    return (
        <>
            {/* Page header */}
            <Box sx={{ mb: 4, textAlign: isMobile ? 'center' : 'left' }}>
                <Typography variant={isMobile ? 'h5' : 'h4'} sx={{ color: BRAND, fontWeight: 'bold', mb: 1 }}>
                    📅 Appointment Management
                </Typography>
                <Typography variant="body1" color="textSecondary">
                    Manage and view all patient appointments
                </Typography>
            </Box>

            {/* Stats overview */}
            {appointments.length > 0 && (
                <Paper elevation={0} sx={{
                    mb: 4, p: { xs: 2, sm: 3 },
                    backgroundColor: '#f8fbff', borderRadius: 3, border: '1px solid #e0f2ff'
                }}>
                    <Typography variant="h6" sx={{ color: BRAND, mb: 2.5, fontWeight: 600 }}>
                        📊 Appointment Overview
                    </Typography>
                    <Grid container spacing={2}>
                        {[
                            { label: 'Total',     value: appointments.length,                                                             icon: <PeopleIcon sx={{ fontSize: 32 }} />,          color: BRAND,    bg: BRAND_LIGHT  },
                            { label: 'Pending',   value: appointments.filter(a => a.status?.toLowerCase() === 'pending').length,         icon: <PendingActionsIcon sx={{ fontSize: 32 }} />,  color: '#D97706', bg: '#FEF3C7'   },
                            { label: 'Confirmed', value: appointments.filter(a => a.status?.toLowerCase() === 'confirmed').length,       icon: <EventAvailableIcon sx={{ fontSize: 32 }} />,  color: '#7C3AED', bg: '#F5F3FF'   },
                            { label: 'Completed', value: appointments.filter(a => a.status?.toLowerCase() === 'completed').length,       icon: <TrendingUpIcon sx={{ fontSize: 32 }} />,      color: SUCCESS,  bg: '#D1FAE5'    },
                            { label: 'Today',     value: todayCount,                                                                      icon: <EventAvailableIcon sx={{ fontSize: 32 }} />,  color: '#0891B2', bg: '#E0F7FA'   },
                            { label: 'Reviews',   value: reviews.length,                                                                  icon: <StarIcon sx={{ fontSize: 32 }} />,            color: GOLD,     bg: GOLD_BG      },
                        ].map((s, i) => (
                            <Grid item xs={6} sm={4} md={2} key={i}>
                                <StatCard {...s} />
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
            )}

            {/* Reviews banner — only shown when reviews exist */}
            {reviews.length > 0 && (
                <Box
                    onClick={() => setOpenReviews(true)}
                    sx={{
                        mb: 4, p: { xs: 2.5, sm: 3 }, borderRadius: '18px',
                        background: `linear-gradient(135deg, ${GOLD_BG}, #FFF7D6)`,
                        border: '1px solid #FDE68A',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        flexWrap: 'wrap', gap: 2, cursor: 'pointer',
                        boxShadow: '0 4px 20px rgba(245,158,11,0.12)',
                        transition: 'box-shadow 0.2s',
                        '&:hover': { boxShadow: '0 8px 32px rgba(245,158,11,0.2)' }
                    }}
                >
                    <Box display="flex" alignItems="center" gap={2}>
                        <Box sx={{
                            width: 52, height: 52, borderRadius: '12px',
                            background: '#FEF3C7', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', border: '1px solid #FDE68A'
                        }}>
                            <ReviewIcon sx={{ color: GOLD, fontSize: 26 }} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontWeight: 800, color: '#92400E', fontSize: '1rem' }}>
                                Patient Feedback
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#B45309' }}>
                                {reviews.length} patient{reviews.length !== 1 ? 's' : ''} shared their experience
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography sx={{ fontWeight: 900, fontSize: '2rem', color: GOLD, lineHeight: 1 }}>
                                {averageRating.toFixed(1)}
                            </Typography>
                            <Rating value={averageRating} precision={0.5} readOnly size="small" sx={{ color: GOLD }} />
                        </Box>
                        <Button
                            variant="contained"
                            onClick={(e) => { e.stopPropagation(); setOpenReviews(true); }}
                            sx={{
                                bgcolor: GOLD, color: '#fff', fontWeight: 700, borderRadius: '10px',
                                boxShadow: '0 4px 12px rgba(245,158,11,0.35)',
                                '&:hover': { bgcolor: '#D97706' }
                            }}
                        >
                            View All Reviews
                        </Button>
                    </Box>
                </Box>
            )}

            {/* Search + quick chips */}
            <Paper elevation={0} sx={{
                mb: 3, p: { xs: 2, sm: 3 },
                backgroundColor: 'white', borderRadius: 3, border: '1px solid #e0e0e0'
            }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="🔍 Search appointments..."
                            variant="outlined"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: BRAND }} /> }}
                            placeholder="Search by patient name, date, or symptoms"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 2,
                                    '&.Mui-focused fieldset': { borderColor: BRAND, borderWidth: 2 }
                                },
                                '& .MuiInputLabel-root.Mui-focused': { color: BRAND }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', gap: 1.5, justifyContent: isMobile ? 'center' : 'flex-end', flexWrap: 'wrap' }}>
                            <Chip label={`Total: ${appointments.length}`}       color="primary" variant="outlined" sx={{ fontWeight: 'bold' }} />
                            <Chip label={`Pending: ${appointments.filter(a => a.status?.toLowerCase() === 'pending').length}`} color="warning" variant="outlined" sx={{ fontWeight: 'bold' }} />
                            <Chip label={`Today: ${todayCount}`}                color="success" variant="outlined" sx={{ fontWeight: 'bold' }} />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {/* Data quality alert */}
            {appointments.filter(a => a.patientName === 'Not provided').length > 0 && (
                <Alert severity="warning" sx={{ mb: 3, borderRadius: 2, '& .MuiAlert-icon': { fontSize: '1.5rem' } }}>
                    <strong>⚠️ Data Quality Notice:</strong>{' '}
                    {appointments.filter(a => a.patientName === 'Not provided').length} appointment(s) have incomplete patient information. Please verify these records.
                </Alert>
            )}

            {/* Table / cards container */}
            <Paper elevation={0} sx={{
                p: { xs: 2, sm: 3 },
                backgroundColor: 'white', borderRadius: 3,
                border: '1px solid #e0e0e0', minHeight: 400
            }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={1}>
                    <Typography variant="h6" sx={{ color: BRAND, fontWeight: 'bold' }}>
                        📋 All Appointments ({filtered.length})
                    </Typography>
                    {isMobile && (
                        <Typography variant="caption" color="textSecondary">Swipe to see more →</Typography>
                    )}
                </Box>

                {filtered.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 8, backgroundColor: '#fafafa', borderRadius: 2, border: '1px dashed #ddd' }}>
                        <Typography variant="h6" color="textSecondary" gutterBottom>📅 No Appointments Found</Typography>
                        <Typography variant="body2" color="textSecondary">
                            {searchTerm ? 'Try adjusting your search terms' : 'No appointments scheduled yet'}
                        </Typography>
                    </Box>
                ) : isMobile ? (
                    filtered.map((a, i) => <MobileCard key={a.id} appointment={a} index={i} />)
                ) : (
                    /*
                     * DESKTOP TABLE
                     * tableLayout: 'fixed' + percentage widths = all 11 columns
                     * fit inside the available width without horizontal scrolling.
                     * overflowX: 'auto' on the container handles edge cases (very
                     * small laptops / tablets) gracefully.
                     */
                    <TableContainer sx={{ overflowX: 'auto', borderRadius: 2, border: `1px solid ${BORDER}` }}>
                        <Table sx={{ width: '100%', tableLayout: 'fixed' }}>
                            <TableHead sx={{ backgroundColor: BRAND }}>
                                <TableRow>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '4%',  py: 1.8, fontSize: '0.78rem' }}>#</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '12%', py: 1.8, fontSize: '0.78rem' }}>Patient</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '6%',  py: 1.8, fontSize: '0.78rem' }}>Age</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '14%', py: 1.8, fontSize: '0.78rem' }}>Contact</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '16%', py: 1.8, fontSize: '0.78rem' }}>Symptoms</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '10%', py: 1.8, fontSize: '0.78rem' }}>Date</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '9%',  py: 1.8, fontSize: '0.78rem' }}>Time</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '8%',  py: 1.8, fontSize: '0.78rem' }}>Status</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '8%',  py: 1.8, fontSize: '0.78rem' }}>Payment</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '7%',  py: 1.8, fontSize: '0.78rem' }}>Review</TableCell>
                                    <TableCell sx={{ color: '#fff', fontWeight: 'bold', width: '8%',  py: 1.8, fontSize: '0.78rem' }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filtered.map((a, index) => (
                                    <TableRow
                                        key={a.id}
                                        hover
                                        sx={{
                                            '&:hover': { backgroundColor: '#f5f9ff' },
                                            backgroundColor: index % 2 === 0 ? 'white' : '#fafafa',
                                            transition: 'background-color 0.2s'
                                        }}
                                    >
                                        {/* # */}
                                        <TableCell sx={{ fontWeight: 'bold', color: '#9CA3AF', fontSize: '0.8rem' }}>
                                            {index + 1}
                                        </TableCell>

                                        {/* Patient */}
                                        <TableCell>
                                            <Typography sx={{ fontWeight: 700, color: BRAND, fontSize: '0.82rem', lineHeight: 1.3 }}>
                                                {a.patientName}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                ID: {a.patientID}
                                            </Typography>
                                        </TableCell>

                                        {/* Age */}
                                        <TableCell>
                                            <Chip
                                                label={`${a.patientAge}${a.patientAge !== 'N/A' ? ' yrs' : ''}`}
                                                size="small"
                                                variant="outlined"
                                                sx={{ borderColor: BRAND, color: BRAND, fontSize: '0.70rem' }}
                                            />
                                        </TableCell>

                                        {/* Contact */}
                                        <TableCell>
                                            <Stack spacing={0.3}>
                                                <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                                                    📱 {a.patientPhone}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                                                    📧 {a.patientEmail}
                                                </Typography>
                                            </Stack>
                                        </TableCell>

                                        {/* Symptoms */}
                                        <TableCell>
                                            <Typography variant="body2" sx={{
                                                overflow: 'hidden', textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap', color: '#374151', fontSize: '0.8rem'
                                            }}>
                                                {a.symptoms}
                                            </Typography>
                                        </TableCell>

                                        {/* Date */}
                                        <TableCell>
                                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#111827', fontSize: '0.8rem' }}>
                                                {formatDate(a.date)}
                                            </Typography>
                                        </TableCell>

                                        {/* Time */}
                                        <TableCell>
                                            <Chip
                                                label={a.timeSlot}
                                                color="primary"
                                                size="small"
                                                variant="outlined"
                                                sx={{ fontWeight: 'bold', borderWidth: 2, fontSize: '0.68rem' }}
                                            />
                                        </TableCell>

                                        {/* Status */}
                                        <TableCell>
                                            <StatusBadge label={a.status} />
                                        </TableCell>

                                        {/* Payment */}
                                        <TableCell>
                                            <Chip
                                                label={a.paymentStatus}
                                                color={a.paymentStatus?.toLowerCase() === 'pending' ? 'warning' : 'success'}
                                                size="small"
                                                sx={{ minWidth: 70, fontSize: '0.70rem' }}
                                            />
                                        </TableCell>

                                        {/* Review — NEW */}
                                        <TableCell>
                                            {a.reviewed ? (
                                                <Box sx={{
                                                    px: 1.2, py: 0.3, borderRadius: '20px',
                                                    background: GOLD_BG, color: GOLD,
                                                    fontWeight: 700, fontSize: '0.68rem',
                                                    border: `1px solid ${GOLD}40`,
                                                    display: 'inline-flex', alignItems: 'center', gap: 0.4
                                                }}>
                                                    <StarIcon sx={{ fontSize: 11 }} /> Reviewed
                                                </Box>
                                            ) : (
                                                <Typography variant="caption" sx={{ color: '#D1D5DB', fontStyle: 'italic' }}>—</Typography>
                                            )}
                                        </TableCell>

                                        {/* Action — Details button */}
                                        <TableCell>
                                            <Button
                                                onClick={() => { setSelectedId(a.id); setShowDetails(true); }}
                                                variant="contained"
                                                size="small"
                                                startIcon={<ViewDetailsIcon />}
                                                sx={{
                                                    backgroundColor: BRAND,
                                                    fontWeight: 'bold',
                                                    fontSize: '0.72rem',
                                                    px: 1.5,
                                                    '&:hover': {
                                                        backgroundColor: BRAND_DARK,
                                                        boxShadow: '0 2px 8px rgba(25,118,210,0.3)'
                                                    }
                                                }}
                                            >
                                                Details
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Paper>

            <ReviewsModal />
        </>
    );
};

// ═══════════════════════════════════════════════════════════════════
//  PAGE WRAPPER
// ═══════════════════════════════════════════════════════════════════
const Appointment = () => {
    const { id }   = useParams();
    const theme    = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f8fafc' }}>
            {/* Mobile AppBar */}
            {isMobile && (
                <AppBar position="fixed" sx={{
                    width: '100%', backgroundColor: BRAND,
                    zIndex: theme.zIndex.drawer + 1
                }}>
                    <Toolbar>
                        <IconButton color="inherit" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2 }}>
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, fontWeight: 700 }}>
                            Doctor Portal
                        </Typography>
                    </Toolbar>
                </AppBar>
            )}

            {/* Side Nav */}
            <Drawer
                variant={isMobile ? 'temporary' : 'permanent'}
                open={isMobile ? mobileOpen : true}
                onClose={handleDrawerToggle}
                sx={{
                    width: drawerWidth, flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth, boxSizing: 'border-box',
                        borderRight: '1px solid #e0e0e0', backgroundColor: '#ffffff'
                    }
                }}
            >
                <SideNav id={id} onClose={handleDrawerToggle} />
            </Drawer>

            {/* Main content */}
            <Main open={!isMobile} sx={{
                flexGrow: 1,
                p: { xs: 2, sm: 3, md: 4 },
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                maxWidth: '100%',
                overflow: 'auto'
            }}>
                {isMobile && <Toolbar />}
                <Container maxWidth="xl" sx={{ p: 0, width: '100%', maxWidth: '100% !important' }}>
                    <DoctorDashboard doctorId={id} />
                </Container>
            </Main>
        </Box>
    );
};

export default withRouter(Appointment);